var _circle, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPicWhatIsProxy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#E4F6FD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "pic-what-is-proxy_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F0F7EC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pic-what-is-proxy_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 44,
    r: 13.5,
    stroke: "#12B886",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 100,
    r: 33.5,
    stroke: "#12B886",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.87 87.354L58 93l-5.87-5.646a3.634 3.634 0 010-5.266A3.943 3.943 0 0154.868 81c.993 0 1.986.361 2.738 1.085l.394.38.394-.38c1.506-1.448 3.97-1.448 5.476 0a3.636 3.636 0 010 5.268z",
    fill: "#F76763"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNTAiIGZpbGw9IiNFNEY2RkQiLz48bWFzayBpZD0id2hhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNTAiIGZpbGw9IiNGMEY3RUMiLz48L21hc2s+PGcgbWFzaz0idXJsKCN3aGEpIj48Y2lyY2xlIGN4PSI1MCIgY3k9IjQ0IiByPSIxMy41IiBzdHJva2U9IiMxMkI4ODYiIHN0cm9rZS13aWR0aD0iMyIvPjxjaXJjbGUgY3g9IjUwIiBjeT0iMTAwIiByPSIzMy41IiBzdHJva2U9IiMxMkI4ODYiIHN0cm9rZS13aWR0aD0iMyIvPjxwYXRoIGQ9Ik02My44NyA4Ny4zNTRMNTggOTNsLTUuODctNS42NDZhMy42MzQgMy42MzQgMCAwIDEgMC01LjI2NkEzLjk0MyAzLjk0MyAwIDAgMSA1NC44NjggODFjLjk5MyAwIDEuOTg2LjM2MSAyLjczOCAxLjA4NWwuMzk0LjM4LjM5NC0uMzhjMS41MDYtMS40NDggMy45Ny0xLjQ0OCA1LjQ3NiAwYTMuNjM2IDMuNjM2IDAgMCAxIDAgNS4yNjh6IiBmaWxsPSIjRjc2NzYzIi8+PC9nPjwvc3ZnPgo=";
export { SvgPicWhatIsProxy as ReactComponent };